import React, { FC } from 'react';

import SelectorForm from './components/SelectorForm';
import { NodeProps } from 'src/presentation/components/pages/ivr/constants/ivrConstants';

const AutomationHandoffNode: FC<NodeProps> = props => {
  return <SelectorForm nodeProps={props} saveConfirmationTitle={'Saving Automation Handoff Node'} />;
};

export default AutomationHandoffNode;
